import useDocumentTitle from "../../util/useDocumentTitle";
import {
  Avatar,
  Paper,
  Button,
  Box,
  CircularProgress,
  Grid,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import TextSnippetRoundedIcon from "@mui/icons-material/TextSnippetRounded";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import MailIcon from "@mui/icons-material/Mail";
import { NavLink } from "react-router-dom";
import { Call, Email } from "@mui/icons-material";
import EmailModal from "../email/EmailModal";
import { EmailType } from "../../common/EmailDetails";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  selectCurrentDispatch,
  selectCurrentProfile,
} from "../../redux/authentication/authSlice";
import { JobOrder, JobRating, JobRatingLabel } from "../../common/JobOrder";
import { 
  MarinerProfile, 
  // MarinerType 
} from "../../common/MarinerProfile";
import { TravelDocument, TravelDocumentOperationType } from "../../common/TravelDocument";
import MyDocuments from "./MyDocuments";
import MyTravelDocuments from "./MyTravelDocuments";
import {
  ProfileDocument,
  ProfileDocumentStatus,
  ProfileDocumentType,
} from "../../common/ProfileDocument";
import checkDocumentExpiration from "../../util/checkDocumentExpiration";
import {
  // useGetJobPostingsQuery,
  useGetProfileJobOrdersQuery,
} from "../../redux/api/jobOrder";
import { useGetProfileDocumentsQuery } from "../../redux/api/profileDocument";
import { useGetTravelDocumentsByProfileQuery } from "../../redux/api/travelDocument";
import "./Home.scss";
import { formatDateString } from "../../common/FormatDateString";
// import { useGetJobApplicationsQuery } from "../../redux/api/jobApplication";
import { Dispatch } from "../../common/Dispatch";
import { useEffect, useState } from "react";
import { TrainingOrder } from "../../common/Training";
import { useGetTrainingOrdersByMarinerQuery } from "../../redux/api/trainingOrder";
import convertDateToString from "../../util/ConvertDateToString";

// type JobPosting = {
//   id: number;
//   date: number;
//   vessel: string;
//   rating: string;
//   port: string;
// };

type MyJob = {
  id: number;
  date: number;
  vesselId: number;
  offsignerId: number;
  vessel: string;
  rating: string;
  port: string;
  travelDate: string;
  startLocation: string;
  endLocation: string;
};

const Home = () => {
  useDocumentTitle("Home");
  const currentProfile: MarinerProfile = useSelector(selectCurrentProfile);
  const currentDispatch: Dispatch = useSelector(selectCurrentDispatch);
  const [trainingOrders, setTrainingOrders] = useState<
    TrainingOrder[]
  >([]);
  const [trainingTravelDocuments, setTrainingTravelDocuments] = useState<TravelDocument[]>([]);
  // const { data: jobPostingsFromApi, isLoading: isJobPostingsLoading } =
  //   useGetJobPostingsQuery({
  //     skip: !currentProfile || !currentProfile?.rating,
  //   });
  // let jobPostings: JobPosting[] = (jobPostingsFromApi as JobOrder[])
  //   ?.map((job: any) => {
  //     return {
  //       id: job.id,
  //       date: job.fillByDate,
  //       vessel: job.vessel?.name,
  //       rating: job.rating,
  //       port: job.port,
  //     };
  //   })
  //   .sort((a: JobPosting, b: JobPosting) =>
  //     new Date(a.date) > new Date(b.date) ? 1 : -1
  //   );

  // const { data: jobApplicationsFromApi, isLoading: isJobApplicationsLoading } =
  //   useGetJobApplicationsQuery(
  //     { appliedById: currentProfile?.id, jobOrderId: undefined },
  //     {
  //       skip:
  //         !currentProfile ||
  //         !currentProfile?.id ||
  //         currentProfile?.type === MarinerType.UNLICENSED,
  //     }
  //   );

  const { data: profileDcumentsFromApi, isLoading: isProfileDocumentsLoading } =
    useGetProfileDocumentsQuery(currentProfile?.id as number, {
      skip: !currentProfile || !currentProfile?.id,
    });

  let myDocuments: ProfileDocument[] = (
    profileDcumentsFromApi as ProfileDocument[]
  )?.filter(
    (doc) =>
      doc.type === ProfileDocumentType.MMC ||
      doc.type === ProfileDocumentType.TWIC ||
      doc.type === ProfileDocumentType.MEDICAL_CERT ||
      doc.type === ProfileDocumentType.PASSPORT
  );

  const hasExpiringMyDocuments = myDocuments
    ?.map((doc) => checkDocumentExpiration(doc))
    .find((item) => item === ProfileDocumentStatus.EXPIRING_SOON);
  const hasExpiredMyDocuments = myDocuments
    ?.map((doc) => checkDocumentExpiration(doc))
    .find((item) => item === ProfileDocumentStatus.EXPIRED);

  const {
    data: profileJobOrdersFromApi,
    isLoading: isProfileJobOrdersLoading,
  } = useGetProfileJobOrdersQuery({
    skip: !currentProfile || !currentProfile?.id,
  });

  let myJobs: MyJob[] = (profileJobOrdersFromApi as JobOrder[])
    ?.map((job: any) => {
      return {
        id: job.id,
        date: job.fillByDate,
        vesselId: job.vessel?.id,
        offsignerId: job.offsigner?.id,
        vessel: job.vessel?.name,
        rating: job.rating,
        port: job.port,
        travelDate:
          job.offsigner?.id === currentProfile?.id
            ? job.offsignerDropoffDate
            : job.onsignerDropoffDate,
        startLocation:
          job.offsigner?.id === currentProfile?.id
            ? job.offsignerLeavingFrom
            : job.onsignerLeavingFrom,
        endLocation:
          job.offsigner?.id === currentProfile?.id
            ? job.offsignerDestination
            : job.onsignerDestination,
      };
    })
    .sort((a: MyJob, b: MyJob) =>
      new Date(a.date) > new Date(b.date) ? 1 : -1
    );

  const myJobOrderIds = myJobs?.map((myJob) => myJob.id);
  const myJobOrderId =
    !!myJobOrderIds && myJobOrderIds.length > 0 ? myJobOrderIds[0] : undefined;

  const { data: travelDocumentsFromApi, isLoading: isTravelDocumentsLoading } =
    useGetTravelDocumentsByProfileQuery(
      {
        jobOrderId: myJobOrderId as number,
        jobOrderIds: myJobOrderIds,
      },
      { skip: !myJobOrderId || !myJobOrderIds }
    );

    const {
      data: trainingOrdersFromApi,
      isLoading: isTrainingOrdersLoading,
      isFetching: isTrainingOrdersFetching,
    } = useGetTrainingOrdersByMarinerQuery(currentProfile?.id as number, {
      skip: !currentProfile || !currentProfile?.id,
    });

    useEffect(() => {
      if (!!currentProfile && !isTrainingOrdersFetching && !isTrainingOrdersLoading) {
        let res: any = JSON.parse(JSON.stringify(trainingOrdersFromApi));
        setTrainingOrders(
          res
            .sort((orderA: any, orderB: any) => {
              return (
                new Date(orderA.expirationDate).getTime() -
                new Date(orderB.expirationDate).getTime()
              );
            })
            .map((order: any) => {
              // convert null values to empty string
              Object.keys(order).forEach(
                (key) => (order[key] = order[key] === null ? "" : order[key])
              );
              // make sure Completed Date and Expiration Date are strings
              if (
                order["completedDate"] !== undefined &&
                order["completedDate"] !== ""
              ) {
                order["completedDate"] = convertDateToString(
                  new Date(order["completedDate"])
                );
              }
              if (
                order["expirationDate"] !== undefined &&
                order["expirationDate"] !== ""
              ) {
                order["expirationDate"] = convertDateToString(
                  new Date(order["expirationDate"])
                );
              }
              return order as TrainingOrder;
            })
        );
        setTrainingTravelDocuments(
          res.map((order: any) => {
            return (order["travelDocuments"]);
          }).reduce((acc : TravelDocument[], current : TravelDocument[]) => [...acc, ...current], [])
        );
      }
    }, [trainingOrdersFromApi, isTrainingOrdersFetching, isTrainingOrdersLoading, currentProfile]);

  const handleTravelDocumentCallback = () => {
    toast.success(
      <p>
        Travel document {TravelDocumentOperationType.DOWNLOAD.toLowerCase()}{" "}
        successful.
      </p>,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      }
    );
  };

  const handleEmailCallBack = () => {
    toast.success(<p>Email sent successfully.</p>, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  if (
    // isJobPostingsLoading ||
    isProfileDocumentsLoading ||
    isTravelDocumentsLoading ||
    isProfileJobOrdersLoading ||
    // isJobApplicationsLoading ||
    !currentProfile
  ) {
    return (
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="page-wrap">
      <div className="home-content">
        <div className="page-header">
          <h1>Home</h1>
        </div>
      </div>
      {hasExpiredMyDocuments && (
        <div className="warning-alert">
          <WarningAmberRoundedIcon color="warning" />
          <h4>You have expired document(s).</h4>
        </div>
      )}
      {!hasExpiredMyDocuments && hasExpiringMyDocuments && (
        <div className="warning-alert">
          <WarningAmberRoundedIcon color="warning" />
          <h4>You have document(s) expiring soon.</h4>
        </div>
      )}
      <Grid container spacing={2}>
        <Grid
          container={true}
          item
          lg={8.5}
          sm={12}
          columnSpacing={2}
          rowSpacing={2}
        >
          <Grid
            className="flex my-0 gc-1 align-items-center npm g-0"
            container={true}
            item
            xs={12}
            columnSpacing={2}
          >
            <Grid item xs={12}>
              <h2>My Jobs</h2>
            </Grid>
            {myJobs?.map((row, index) => {
              return (
                <Grid item md={4} xs={12} key={"myJobsGrid" + index}>
                  <Paper className="home-card icon-navy">
                    <div>
                      <div className="flex gc-1 align-items-center mb-0">
                        <h3>{row.vessel}</h3>
                        {index === 0 &&
                          currentDispatch?.vesselId === row.vesselId &&
                          (new Date(row.date) < new Date() ||
                            currentDispatch?.profileId === row.offsignerId) && (
                            <span className="onboard-flag">Onboard</span>
                          )}
                      </div>
                      <div className="location-header">
                        <h6>{row.port}</h6>
                      </div>
                      <div className="flex my-0 gc-1 align-items-center">
                        <CalendarTodayRoundedIcon />{" "}
                        <h4>{formatDateString(row.date.toString())} </h4>
                      </div>
                      <div className="flex my-0 gc-1 align-items-center">
                        <PersonRoundedIcon />{" "}
                        <h5>{JobRatingLabel[row.rating as JobRating]}</h5>
                      </div>
                    </div>
                  </Paper>
                </Grid>
              );
            })}
            {(!myJobs || myJobs.length === 0) && (
              <Grid item xs={12} key={"myJobsGrid_empty"}>
                <Paper className="home-card">
                  You currently have no jobs assigned.
                </Paper>
              </Grid>
            )}
          </Grid>
          <Grid
            className="flex my-0 gc-1 align-items-center npm g-0"
            container={true}
            item
            xs={12}
            columnSpacing={2}
          >
            <Grid item xs={12}>
              <h2>My Training</h2>
            </Grid>
            {trainingOrders?.map((row, index) => {
              return (
                <Grid item md={4} xs={12} key={"myJobsGrid" + index}>
                  <Paper className="home-card icon-navy">
                    <div>
                      <div className="flex gc-1 align-items-center mb-0">
                        <h3>{row.training?.name}</h3>
                      </div>
                      <div className="location-header">
                        <h6>{row.trainingLocation?.name}</h6>
                      </div>
                      { !!row?.startDate &&  !!row?.endDate && <div className="flex my-0 gc-1 align-items-center">
                        <CalendarTodayRoundedIcon />{" "}
                        <h4>{formatDateString(row?.startDate.toString()) + ` - ` + formatDateString(row?.endDate.toString())} </h4>
                      </div>}
                    </div>
                  </Paper>
                </Grid>
              );
            })}
            {(!trainingOrders || trainingOrders.length === 0) && (
              <Grid item xs={12} key={"myJobsGrid_empty"}>
                <Paper className="home-card">
                  You currently have no trainings assigned.
                </Paper>
              </Grid>
            )}
          </Grid>
          <Grid
            className="flex my-0 gc-1 align-items-center g-0"
            container={true}
            item
            xs={12}
            columnSpacing={2}
          >
            <Grid item xs={12}>
              <h2>Upcoming Job Travel</h2>
            </Grid>
            {myJobs?.map((row, index) => {
              return (
                !!row.startLocation && !!row.endLocation && <Grid item md={4} xs={12} key={"myTravelGrid" + index}>
                  <Paper className="Upcoming-Card">
                    <div>
                      <div>
                        <h5 className="travel-header flex-wrap">
                          {formatDateString(row.travelDate?.toString())}{" "}
                        </h5>
                        <div>
                          <h6 className="flex mt-6 gc-0 flex-wrap">
                            {row.startLocation} <TrendingFlatIcon />{" "}
                            {row.endLocation}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </Paper>
                </Grid>
              );
            })}
            {(!myJobs || myJobs.filter((job : MyJob) => !!job.startLocation && !!job.endLocation).length === 0) && (
              <Grid item xs={12} key={"myTravelGrid_empty"}>
                <Paper className="home-card">
                  You do not have any upcoming travel.
                </Paper>
              </Grid>
            )}
          </Grid>
          <Grid
            className="flex my-0 gc-1 align-items-center g-0"
            container={true}
            item
            xs={12}
            columnSpacing={2}
          >
            <Grid item xs={12}>
              <h2>Upcoming Training Travel</h2>
            </Grid>
            {trainingOrders?.map((row, index) => {
              return (
                !!row.marinerLeavingFrom && !!row.marinerDestination && <Grid item md={4} xs={12} key={"myTravelGrid" + index}>
                  <Paper className="Upcoming-Card">
                    <div>
                      <div>
                        {!!row.marinerPickupDate && <h5 className="travel-header flex-wrap">
                          {formatDateString(row.marinerPickupDate?.toString())}{" "}
                        </h5>}
                        <div>
                          <h6 className="flex mt-6 gc-0 flex-wrap">
                            {row.marinerLeavingFrom} <TrendingFlatIcon />{" "}
                            {row.marinerDestination}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </Paper>
                </Grid>
              );
            })}
            {(!trainingOrders || trainingOrders.filter((training : TrainingOrder) => !!training.marinerLeavingFrom && !!training.marinerDestination).length === 0) && (
              <Grid item xs={12} key={"myTravelGrid_empty"}>
                <Paper className="home-card">
                  You do not have any upcoming travel.
                </Paper>
              </Grid>
            )}
          </Grid>
          <Grid container={true} item xs={12} rowSpacing={2}>
            <Grid item xs={12}>
              <Paper className="home-card">
                <h3>Travel Documents</h3>
                {!!travelDocumentsFromApi && (
                  // TODO: set JobOrderId
                  // <div >
                  <h5>
                    <MyTravelDocuments
                      orderId={15898}
                      myTravelDocuments={
                        !!travelDocumentsFromApi ? travelDocumentsFromApi : []
                      }
                      parentCallback={handleTravelDocumentCallback}
                    />
                  </h5>
                )}
              </Paper>
            </Grid>
          </Grid>
          <Grid container={true} item xs={12} rowSpacing={2}>
            <Grid item xs={12}>
              <Paper className="home-card">
                <h3>Training Travel Documents</h3>
                {!!trainingOrders && (
                  <h5>
                    <MyTravelDocuments
                      orderId={15898}
                      training={true}
                      myTravelDocuments={
                        !!trainingTravelDocuments ? trainingTravelDocuments : []
                      }
                      parentCallback={handleTravelDocumentCallback}
                    />
                  </h5>
                )}
              </Paper>
            </Grid>
          </Grid>
          {/* <Grid
            className="flex-col g-0"
            container={true}
            item
            xs={12}
            rowSpacing={2}
            columnSpacing={2}
          >
            <Grid item xs={12}>
              <h2>Job Postings </h2>
              <span>
                Open jobs that might interest you. View all job postings
              </span>
              {
                <NavLink className="blue-link inline-link" to={`/jobBoard`}>
                  here
                </NavLink>
              }
            </Grid>
          </Grid>
          <Grid className="p-1" container={true} item xs={12} columnSpacing={2}>
            {jobPostings?.map((row, index) => {
              return (
                <Grid item md={4} xs={12} key={"jobPostingGrid" + index}>
                  <div className="home-card icon-navy">
                    <Paper key={"jobPosting" + index}>
                      <div>
                        <h3>{row.vessel}</h3>
                        <div className="location-header">
                          <h6>{row.port}</h6>
                        </div>
                        <div className="flex my-0 gc-1 align-items-center">
                          <CalendarTodayRoundedIcon />
                          <h4>{formatDateString(row.date.toString())} </h4>
                        </div>
                        <div className="flex my-0 gc-1 align-items-center">
                          <PersonRoundedIcon />
                          <h5>{JobRatingLabel[row.rating as JobRating]}</h5>
                        </div>
                        {!!jobApplicationsFromApi &&
                        jobApplicationsFromApi.some(
                          (jobApplication) =>
                            jobApplication.jobOrderId === row.id
                        ) ? (
                          <div className="h4-green">Applied</div>
                        ) : (
                          <div>
                            <NavLink
                              to={`/jobBoard/${row.id}`}
                              className="blue-link flex justify-content-end"
                            >
                              View Job
                            </NavLink>
                          </div>
                        )}
                      </div>
                    </Paper>
                  </div>
                </Grid>
              );
            })}
          </Grid> */}
        </Grid>
        <Grid
          className="side-bar"
          container={true}
          item
          lg={3.5}
          sm={12}
          columnSpacing={2}
          rowSpacing={2}
        >
          <Grid item md={12} sm={6} xs={12}>
            <Paper className="flex-col g-1 home-card">
              <span className="flex my-0 gc-1 align-items-center icon-navy no-margin">
                <Avatar
                  sx={{
                    // bgcolor: "",
                    height: 30,
                    width: 30,
                  }}
                >
                  {currentProfile?.firstName
                    ? currentProfile?.firstName?.charAt(0)
                    : undefined}
                </Avatar>
                <h3 className="no-margin">
                  {currentProfile?.firstName} {currentProfile?.lastName}
                </h3>
              </span>
              <div className="flex-col g-1">
                <div className="flex my-0 gc-1 align-items-center icon-navy no-margin">
                  <PersonRoundedIcon />{" "}
                  <h5>{JobRatingLabel[currentProfile?.rating as JobRating]}</h5>
                </div>
                <div className="flex my-0 gc-1 align-items-center text-wrap icon-navy no-margin">
                  <MailIcon /> <h5>{currentProfile?.email}</h5>
                </div>
                <div className="flex my-0 gc-1 align-items-center icon-navy no-margin">
                  <Call /> <h5>{currentProfile?.phone}</h5>
                </div>
                <div>
                  <NavLink
                    to={`/profiles/${currentProfile?.id as number}`}
                    className="blue-link flex justify-content-end"
                  >
                    <EditRoundedIcon /> Edit Profile
                  </NavLink>
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid
            container={true}
            item
            md={12}
            sm={6}
            xs={12}
            rowSpacing={2}
            columnSpacing={2}
          >
            <Grid item xs={12}>
              <Paper className="home-card">
                <h3> My Documents</h3>
                {!!currentProfile?.id && (
                  <div>
                    <MyDocuments
                      profileId={currentProfile?.id as number}
                      myDocuments={!!myDocuments ? myDocuments : []}
                    />
                    <div>
                      <NavLink
                        to={`/profiles/${currentProfile?.id}`}
                        className="blue-link flex justify-content-end"
                      >
                        <TextSnippetRoundedIcon /> All Documents
                      </NavLink>
                    </div>
                  </div>
                )}
              </Paper>
            </Grid>
          </Grid>
          <Grid container={true} item xs={12} rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12}>
              <Paper className="flex-col g-1">
                <h3>TOTE Services Contact</h3>
                <div className="page-header no-margin">
                  {!currentDispatch ? (
                    <EmailModal
                      key={EmailType.EMAIL_TO_CREWING}
                      email=""
                      emailType={EmailType.EMAIL_TO_CREWING}
                      parentCallback={handleEmailCallBack}
                    >
                      <Button className="blue-link-button">
                        <Email />
                        Email
                      </Button>
                    </EmailModal>
                  ) : (
                    <Button disabled={true} className="blue-link-button">
                      <Email />
                      Email
                    </Button>
                  )}
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Home;
